import type { oz } from '@weft/utils';
import { created } from '../../utils';
import { NewSystemEventSchema } from './new-system-event-schema';

export const SystemEventSchema = created(NewSystemEventSchema).openapi('SystemEvent');

export type SystemEvent = oz.infer<typeof SystemEventSchema>;